import { cloneDeep, omit } from 'lodash'

export const CompanyFormat = {
  bidderCompanyName: {
    label: '企业名称',
    hint: '请填写企业（投标人）全称',
    type: 'text',
  },
  orgLegalPerson: {
    label: '企业法人',
    hint: '请填写企业法人姓名',
    type: 'text',
  },
  bidderLinkAdress: {
    label: '企业办公地址',
    hint: '',
    type: 'text',
  },
  certificatesNo: {
    label: '法人身份证号码',
    hint: '',
    type: 'text',
  },
  certificatesEndDate: {
    label: '法人身份证到期日',
    hint: '',
    type: 'time',
  },
  deputyMaterialFileId: {
    label: '法定代表人证件证明材料',
    hint: '',
    type: 'file',
  },
  address: {
    label: '企业地址',
    hint: '请填写企业详细地址用于快递或票务',
    type: 'text',
  },
  orgTel: {
    label: '企业电话',
    hint: '请填写企业联系方式（固话）',
    type: 'text',
  },
  linkMan: {
    label: '联系人',
    hint: '请填写保函申请人姓名',
    type: 'text',
  },
  bidderMobilePhone: {
    label: '联系方式',
    hint: '请填写保函申请人手机号码',
    type: 'text',
  },
  bidderLinkMail: {
    label: '联系邮箱',
    hint: '请填写邮箱用于接受电子保单文件信息',
    type: 'text',
  },
  bankCardNo: {
    label: '银行账户号码',
    hint: '',
    type: 'text',
  },
  bankCardName: {
    label: '银行账户户名',
    hint: '',
    type: 'text',
  },
  businessLicense: {
    label: '营业执照',
    hint: '',
    type: 'file',
  },
  openingPermit: {
    label: '开户许可证',
    hint: '',
    type: 'file',
  },
  attr1: {
    label: '年度出具分离式投标保函承诺函',
    hint: '',
    type: 'file',
  },
  attr2: {
    label: '批量分离式保函委托协议盖章',
    hint: '',
    type: 'file',
  },
  attr3: {
    label: '法定代表人证明书及授权委托证明',
    hint: '',
    type: 'file',
  },
  isFirstApply: {
    label: '是否在平台首次申请保函',
    hint: '',
    type: 'boolean',
  },
  expressNum: {
    label: '快递单号',
    hint: '',
    type: 'text',
  },
  bidderSocialCreditCode: {
    label: '统一社会信用代码',
    hint: '未三证合一的请填写组织机构代码',
    type: 'text',
  },
  bidderQualification: {
    label: '是否具有企业资质',
    hint: '',
    type: 'boolean',
  },
  dutyPaidProof: {
    label: '资质文件',
    hint: '',
    type: 'file',
  },
}

export const GuarantorsInfoFormat = {
  channelPartnerName: {
    label: '担保机构名称',
    hint: '请填写担保机构名称',
    type: 'text',
  },
  channelPartnerTelNo: {
    label: '担保机构电话',
    hint: '请填写担保机构电话',
    type: 'text',
  }
}


export const ProjectFormat = {
  // sourceOfBiddingFunds: {
  //   label: '项目来源',
  //   hint: '非招财进宝平台项目请选择其他',
  //   type: 'text',
  // },
  postAddress: {
    label: '纸质保函邮寄地址',
    hint: '',
    type: 'text',
  },
  projectName: {
    label: '标段名称',
    hint: '请填写真实项目名称',
    type: 'text',
  },
  projectCode: {
    label: '项目编号',
    hint: '请填写真实项目的编号或标段（包）编号',
    type: 'text',
  },
  bidderLinkName: {
    label: '项目联系人',
    hint: '请填写项目联系人姓名',
    type: 'text',
  },
  tenderMail: {
    label: '项目联系人邮箱',
    hint: '请填写项目联系人邮箱',
    type: 'text',
  },
  tenderCompanyName: {
    label: '招标人名称',
    hint: '请填写招标人全称',
    type: 'text',
  },
  tenderMobilePhone: {
    label: '招标人电话',
    hint: '请填写招标人手机号码',
    type: 'text',
  },
  tenderLinkAddress: {
    label: '招标人地址',
    hint: '请填写招标人地址',
    type: 'text',
  },
  agentName: {
    label: '代理机构名称',
    hint: '请填写代理机构名称',
    type: 'text',
  },
  tenderSocialCreditCode: {
    label: '招标人统一社会信用代码',
    hint: '未三证合一的请填写组织机构代码',
    type: 'text',
  },
  tenderFileId: {
    label: '招标文件',
    hint: '',
    type: 'file',
  },
  openingDate: {
    label: '开标时间',
    hint: '请选择开标时间，若开标时间变更，请在招标文件处上传变更文件',
    type: 'text',
  },
  validityPeriod: {
    label: '投标有效期（天）',
    hint: '请选择投标有效期',
    type: 'text',
  },
  projectRegion: {
    label: '项目地区',
    hint: '请选择省/市/区',
    type: 'region',
  },
  guaranteeStartDate: {
    label: '开标日期',
    hint: '请选择开标日期',
    type: 'text',
  },
  validityPeriod: {
    label: '投标有效期（天）',
    hint: '请选择投标有效期',
    type: 'text',
  },
  guaranteeEndDate: {
    label: '保单有效截止日期',
    hint: '',
    type: 'text',
  },
  tenderMateriaFileId: {
    label: '中标通知书',
    hint: '',
    type: 'file',
  },
  validityPeriodAgreement: {
    label: '担保期限（天）',
    hint: '请选择投保期限',
    type: 'text',
  },
  writingParty: {
    label: '出函方',
    hint: '请填写出函方',
    type: 'dict',
    dictCode: 'PERFORMANCE_GUARANTEE_TYPE'
  },
  performGuaranteeType:{
    label: '履约保函类型',
    hint: '请填写履约保函类型',
    type: 'dict',
    dictCode: 'PERFORM_GUARANTEE_TYPE'
  },
  guaranteeApplyPdfId: {
    label: '保函申请书',
    hint: '',
    type: 'file',
  },

}

export const OrderPostInfoFormat= {
  linkMan: {
    label: '收件人',
    hint: '请填写收件人名称',
    type: 'text',
  },
  linkMobile: {
    label: '联系电话',
    hint: '请填写联系电话',
    type: 'text',
  },
  postAddress: {
    label: '联系地址',
    hint: '请填写联系地址',
    type: 'text',
  },
  guaranteEexpressNumber: {
    label: '邮寄单号',
    hint: '请填写邮寄单号',
    type: 'text',
  },
  guaranteEexpressType: {
    label: '快递公司',
    hint: '请填写快递公司',
    type: 'dict',
    dictCode: 'EXPRESS_TYPE'
  },
  electronicGuaranteeFileId: {
    label: '保函扫描件',
    hint: '',
    type: 'file'
  },
}


// 基础银行保函配置
const BaseBankGuarantee = {
  n: '银行保函',
  n_dz: '电子-银行保函',
  u: require('@/assets/ordelist/yinhang@3x.png'),
  company: [
    'bidderCompanyName',
    'bidderSocialCreditCode',
    'bidderLinkAdress',
    'orgLegalPerson',
    'certificatesNo',
    'linkMan',
    'bidderMobilePhone',
    'businessLicense',
  ],
  project: [
    'projectName',
    'projectCode',
    'openingDate',
    'validityPeriod',
    'tenderCompanyName',
    'projectRegion',
    'tenderLinkAddress',
    'tenderFileId'
  ],
};

export const ApplyType = {
  0: {
    n: '保函类型',
  },
  1: {
    n: '全部',
  },
  9600: {
    n: '电子担保保函',
    n_dz: '电子担保保函',
    path: '/guaranteeBankView',
    u: require('@/assets/ordelist/dianzibaohan@3x.png'),
    company: [
      'bidderCompanyName',
      'orgLegalPerson',
      'address',
      'orgTel',
      'linkMan',
      'bidderMobilePhone',
      'businessLicense',
    ],
    project: [
      'projectName',
      'projectCode',
      'tenderCompanyName',
      'tenderLinkAddress',
      'agentName',
      'tenderFileId',
      'openingDate',
      'validityPeriod',
      'projectRegion',
      'guaranteeApplyPdfId',
    ],
    guarantors: [
      'channelPartnerName',
      'channelPartnerTelNo',
    ],
  },
  8000: {
    ...BaseBankGuarantee,
    path: '/applyBankMain',
    project: [
      ...BaseBankGuarantee.project,
      'postAddress',
      'agentName',
    ],
    orderPost: [
      'linkMan',
      'linkMobile',
      'postAddress',
      'guaranteEexpressNumber',
      'guaranteEexpressType',
      'electronicGuaranteeFileId'
    ],
    //安徽移动
    ahyd: {
      ...BaseBankGuarantee,
      n: BaseBankGuarantee.n_dz,
      path: '/anhui/bank',
      company: [
        ...BaseBankGuarantee.company,
        'certificatesEndDate',
        'deputyMaterialFileId',
      ],
    },
    //贵州银行
    gzyh: {
      ...BaseBankGuarantee,
      n: BaseBankGuarantee.n_dz,
      path: '/guizhouBank/bank',
      company: [
        ...BaseBankGuarantee.company,
        'certificatesEndDate',
        'deputyMaterialFileId',
      ],
    },
    //电子银行保函
    exectronicBank: {
      ...BaseBankGuarantee,
      n: BaseBankGuarantee.n_dz,
      path: '/applyBankMain',
      project: [
        ...BaseBankGuarantee.project,
        'agentName',
      ],
    },
  },
  7000: {
    n: '保险保函',
    n_dz: '电子-保险保函',
    u: require('@/assets/ordelist/baoxian@3x.png'),
    path: '/applyInsurance',
    company: [
      'bidderCompanyName',
      'address',
      'linkMan',
      'bidderMobilePhone',
      'bidderLinkMail',
      'bidderSocialCreditCode',
    ],
    project: [
      'projectName',
      'tenderCompanyName',
      'tenderLinkAddress',
      'tenderSocialCreditCode',
      'bidderLinkName',
      'tenderMobilePhone',
      'tenderMail',
      'tenderFileId',
      'guaranteeStartDate',
      'validityPeriod',
      'guaranteeEndDate',
    ],
    guarantors: [
      'channelPartnerName',
      'channelPartnerTelNo',
    ],
    orderPost: [
      'linkMan',
      'linkMobile',
      'postAddress',
      'guaranteEexpressNumber',
      'guaranteEexpressType',
      'electronicGuaranteeFileId'
    ],
  },
  9100: {
    n: '履约保函',
    n_dz: '电子-履约保函',
    u: require('@/assets/ordelist/zhiliang@3x.png'),
    path: '/applicationPerformance',
    company: [
      'bidderCompanyName',
      'orgLegalPerson',
      'linkMan',
      'bidderMobilePhone',
      'bidderSocialCreditCode',
      'bidderQualification',
      'dutyPaidProof',
    ],
    project: [
      'projectName',
      'projectCode',
      'tenderCompanyName',
      'tenderFileId',
      'projectRegion',
      'validityPeriodAgreement',
      'tenderMateriaFileId',
      'writingParty',
      'performGuaranteeType',
    ],
  },
  9200: {
    n: '预付款保函',
    n_dz: '电子-预付款保函',
    u: require('@/assets/ordelist/baoxian@3x.png'),
  },
  9300: {
    n: '质量保函',
    n_dz: '电子-质量保函',
    u: require('@/assets/ordelist/baoxian@3x.png'),
  },
  9400: {
    n: '农民工工资保函',
    n_dz: '电子-农民工工资保函',
    u: require('@/assets/ordelist/baoxian@3x.png'),
  },

}

export const GuaranteeApplyStatus = {
  0: {
    n: '保函状态',
  },
  1: {
    n: '全部',
  },
  1000: {
    n: '待付款',
    k: 1000,
    c: '#409EFF',
  },
  2000: {
    n: '待审核',
    k: 2000,
    c: '#409EFF',
  },
  3000: {
    n: '审核驳回',
    k: 3000,
    c: '#2474F8',
  },
  4000: {
    n: '待重新签订承诺书',
    k: 4000,
    c: '#409EFF',
  },
  500: {
    n: '待签订承诺书',
    k: -1,
    c: '#409EFF',
  },
  4100: {
    n: '待出函',
    k: 4100,
    c: '#999999',
  },
  5000: {
    n: '已出函',
    k: 5000,
    c: '#999999',
  },
  6000: {
    n: '已取消',
    k: 6000,
    c: '#999999',
  },
}

export const GuaranteeApplyStatusIns = {
  0: {
    n: '保函状态',
  },
  1: {
    n: '全部',
  },
  1000: {
    n: '待付款',
    k: 1000,
    c: '#409EFF',
  },
  2000: {
    n: '待审核',
    k: 2000,
    c: '#409EFF',
  },
  3000: {
    n: '审核驳回',
    k: 3000,
    c: '#2474F8',
  },
  4000: {
    n: '待重新上传投保单',
    k: 4000,
    c: '#409EFF',
  },
  500: {
    n: '待上传投保单',
    k: -1,
    c: '#409EFF',
  },
  4100: {
    n: '待出函',
    k: 4100,
    c: '#999999',
  },
  5000: {
    n: '已出函',
    k: 5000,
    c: '#999999',
  },
  6000: {
    n: '已取消',
    k: 6000,
    c: '#999999',
  },
}

export const GuaranteeApplyStatusFirst = {
  0: {
    n: '保函状态',
  },
  1: {
    n: '全部',
  },
  1000: {
    n: '待派单',
    k: 1000,
    c: '#999999',
  },
  1100: {
    n: '待审核',
    k: 2000,
    c: '#409EFF',
  },
  1500: {
    n: '待付款',
    k: 1000,
    c: '#409EFF',
  },
  3000: {
    n: '已驳回',
    k: 3000,
    c: '#2474F8',
  },
  4100: {
    n: '待出函',
    k: 4100,
    c: '#999999',
  },
  5000: {
    n: '已出函',
    k: 5000,
    c: '#999999',
  },
  6000: {
    n: '已取消',
    k: 6000,
    c: '#999999',
  },
}

export const GuaranteeApplyStatusElectBank = {
  0: {
    n: '保函状态',
  },
  1: {
    n: '全部',
  },
  1000: {
    n: '待付款',
    k: 1000,
    c: '#409EFF',
  },
  2000: {
    n: '待审核',
    k: 2000,
    c: '#409EFF',
  },
  3000: {
    n: '审核驳回',
    k: 3000,
    c: '#2474F8',
  },
  4000: {
    n: '待重新签订申请书',
    k: 4000,
    c: '#409EFF',
  },
  500: {
    n: '待签订申请书',
    k: -1,
    c: '#409EFF',
  },
  4100: {
    n: '待出函',
    k: 4100,
    c: '#999999',
  },
  5000: {
    n: '已出函',
    k: 5000,
    c: '#999999',
  },
  6000: {
    n: '已取消',
    k: 6000,
    c: '#999999',
  },
}
//保险保函
export const InsGuaranteeApplyStatus = {
  500: { n: '上传投保单', k: ['500'], isShowExectronic:['0'] },
  1000: { n: '支付', k: ['1000'] },
  2000: { n: '平台审核', k: ['2000'] },
  3000: { n: '审核驳回', k: ['3000'] },
  4000: { n: '重新上传投保单', k: ['4000'], isShowExectronic:['0'] },
  5000: { n: '平台出函', k: ['4100', '5000'] },
  6000: { n: '已取消', k: ['6000'] },
}
//纸质银行保函
export const BankGuaranteeApplyStatus = {
  500: { n: '签订申请书', k: ['500'], isShowApi:['ahyd','gzyh']  },
  1000: { n: '支付', k: ['1000'] },
  2000: { n: '平台审核', k: ['2000'] },
  3000: { n: '审核驳回', k: ['3000'] },
  4000: { n: '重新签订申请书', k: ['4000'], isShowApi:['ahyd','gzyh']  },
  5000: { n: '平台出函', k: ['4100', '5000'] },
  6000: { n: '已取消', k: ['6000'] },
}
//电子担保保函
export const ElectronicGuaranteeApplyStatus = {
  500: { n: '签订承诺书', k: ['500'] , isHideApi:[], isNeedCommitment:['1'] },
  1000: { n: '支付', k: ['1000'] },
  2000: { n: '平台审核', k: ['2000'] },
  3000: { n: '审核驳回', k: ['3000'] },
  4000: { n: '重新签订承诺书', k: ['4000'], isHideApi:[], isNeedCommitment:['1']  },
  5000: { n: '平台出函', k: ['4100', '5000'] },
  6000: { n: '已取消', k: ['6000'] },
}
//履约保函
export const PerformanceGuaranteeApplyStatus = {
  1000: { n: '待派单', k: ['1000'] },
  1100: { n: '待审核', k: ['1100'] },
  1500: { n: '待付款', k: ['1500'] },
  3000: { n: '已驳回', k: ['3000'] },
  4100: { n: '待出函', k: ['4100'] },
  5000: { n: '已出函', k: ['5000'] },
  6000: { n: '已取消', k: ['6000'] },
}

export function filterData(type, isExectronic, guaranteeApplyStatus, apiId, isNeedCommitment) {
  const m = {
    7000: InsGuaranteeApplyStatus,
    8000: BankGuaranteeApplyStatus,
    9600: ElectronicGuaranteeApplyStatus,
    9100: PerformanceGuaranteeApplyStatus,
  }
  let result = cloneDeep(m[type] || {});
  // 根据当前申请状态过滤不需要显示的状态
  if (guaranteeApplyStatus < 3000 || guaranteeApplyStatus > 4000) {
    result = omit(result, ['3000', '4000']);
  } else if (guaranteeApplyStatus === 4000) {
    result = omit(result, ['3000']);
  } else if (guaranteeApplyStatus === 3000) {
    result = omit(result, ['4000', '4100', '5000']);
  }
  if (guaranteeApplyStatus != 6000) {
    result = omit(result, ['6000']);
  }
    if (apiId) {
      result = filterByConfigKey(result, 'isShowApi', apiId);
      result = filterHideByConfigKey(result, 'isHideApi', apiId);
    }
    if (isNeedCommitment) {
      result = filterByConfigKey(result, 'isNeedCommitment', isNeedCommitment);
    }

    if (isExectronic) {
      result = filterByConfigKey(result, 'isShowExectronic', isExectronic);
    }

  return result
}

function filterByConfigKey(statusObj, configKey, value) {
  return Object.fromEntries(
    Object.entries(statusObj).filter(([_, config]) => {
      return !config[configKey] || config[configKey].includes(value);
    })
  );
}

function filterHideByConfigKey(statusObj, configKey, value) {
  return Object.fromEntries(
    Object.entries(statusObj).filter(([_, config]) => {
      return !config[configKey] || !config[configKey].includes(value);
    })
  );
}


export function screenData(type) {
  const m = {
    7000: '待上传投保单',
    8000: '待签订申请书',
    9600: '待签订承诺书',
    9100: '待签订承诺书',
    1: '待签订承诺书',
  }
  GuaranteeApplyStatus[500].n = m[type]?m[type]:'待签订承诺书'
}

export function GetApiCodeById(id){
  let types = {
    '2': 'zcjb',
    '7': 'ahyd',
    '8': 'zcm',
    '9': 'sxdd',
    '10': 'sdgs',
    '11': 'zcjbv6',
    '12': 'cqsw',
    '13': 'hnkyV6',
    '14': 'fd',
    '15': 'stdv6',
    '16': 'gzyh',
    '17': 'shgz',
    '18': 'cqsw_v6',
    '20': 'zcjbv6-gzxyld',
    '24': 'zcjbv6-gxjh',
    '25': 'zcjbv6-bsgzw',
  }
  return types[id]
}
